import { MyPicks } from 'components/driving/car-comparison/my-picks'
export default MyPicks
